import { css } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import { Dialog, DialogContent, IconButton, useTheme } from "@mui/material";
import { MouseEventHandler } from "react";
import { match } from "ts-pattern";

import Loading from "~/components/me/bento/Loading";
import RetriableError from "~/components/me/bento/RetriableError";
import ContentBodyLayout from "~/components/me/bento/content/ContentBodyLayout";
import DialogBody from "~/components/me/bento/content/quest-memory/DialogBody";
import { useMeQuestTaskContent } from "~/components/me/bento/lib";
import { useOpenContentModal } from "~/components/me/hooks";
import { ContentName } from "~/components/me/lib";
import { engFont } from "~/lib/client/fonts";
import {
  MeQuestTaskContentQuery,
  Sdk,
  UserQuestTaskProgressStatus,
} from "~/lib/graphql/client";

const contentName: ContentName = "QuestMemory";

const QuestMemory = ({ client }: { client: Sdk }) => {
  const result = useMeQuestTaskContent(client);
  const theme = useTheme();
  const { openedContent, openContentModal, closeContentModal } =
    useOpenContentModal();

  const isOpen = openedContent === contentName && result.status === "success";
  const openModal = () => {
    if (result.status !== "success") return;
    openContentModal(contentName);
  };
  const closeModal = () => closeContentModal();

  return (
    <>
      {match(result)
        .with({ status: "pending" }, () => <Loading />)
        .with({ status: "error" }, (matched) => (
          <RetriableError reload={matched.refetch} />
        ))
        .with({ status: "success" }, (matched) => (
          <Body content={matched.data} onClick={openModal} />
        ))
        .exhaustive()}
      {result.status === "success" && (
        <Dialog
          open={isOpen}
          onClose={closeModal}
          fullWidth
          PaperProps={{
            sx: {
              width: "100%",
              height: "80vh",
              m: 1,
            },
          }}
          maxWidth={"lg"}
        >
          <DialogContent>
            <IconButton onClick={closeModal}>
              <CloseIcon sx={{ color: theme.palette.text.primary }} />
            </IconButton>
            <DialogBody content={result.data} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

const Body = ({
  content,
  onClick,
}: {
  content: MeQuestTaskContentQuery;
  onClick: MouseEventHandler;
}) => {
  return (
    <ContentBodyLayout onClick={onClick} label={"Quest Memory"}>
      <div css={rootStyle}>
        <CollectionsOutlinedIcon sx={iconStyle} />
        <p css={questTaskCountStyle} className={engFont.className}>
          {
            content.me.userQuestTaskProgresses.filter(
              (p) => p.status === UserQuestTaskProgressStatus.Verified
            ).length
          }
        </p>
      </div>
    </ContentBodyLayout>
  );
};

// 中央揃え
const rootStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  align-self: center;

  width: 100%;
  height: 100%;
`;

const iconStyle = {
  width: "78px",
  height: "78px",
};

const questTaskCountStyle = css`
  font-size: 40px;
  font-weight: 700;
  margin: 0;
`;

export default QuestMemory;
